import {
  DisablerStatus,
  DutyType,
  type Vehicle,
} from '@cobliteam/common-types';

import { DeviceType } from '../../__generated__/graphql';

export const isDeviceTypeDashcam = (
  deviceType: DeviceType | string
): boolean => {
  return deviceType === DeviceType.Dashcam;
};

export const isVehicleDashcam = (vehicle: Vehicle): boolean =>
  vehicle.deviceType !== undefined && isDeviceTypeDashcam(vehicle.deviceType);

export const isDeviceTypeOverSpeedingAlarm = (
  deviceType: DeviceType | string
): boolean => {
  return (
    deviceType === DeviceType.IButton ||
    deviceType === DeviceType.Blocker ||
    deviceType === DeviceType.Immobilizer ||
    deviceType === DeviceType.Buzzer ||
    deviceType === DeviceType.PlugAndPlayBuzzer
  );
};

export const isVehicleWithOverSpeedingAlarm = (vehicle: Vehicle): boolean =>
  vehicle.deviceType !== undefined &&
  isDeviceTypeOverSpeedingAlarm(vehicle.deviceType);

export const isImmobilizedVehicle = (vehicle: Vehicle): boolean => {
  if (vehicle.deviceType !== undefined) {
    const deviceType = vehicle.deviceType;
    if (deviceType === DeviceType.Immobilizer) {
      const disablerStatus = Object.values(DisablerStatus).find(
        (status: string) => status === vehicle.disablerStatus?.status
      );
      return (
        disablerStatus === DisablerStatus.Disabled ||
        disablerStatus === DisablerStatus.Disabling
      );
    }
  }
  return false;
};

export const getVehicleDutyType = (vehicle: Vehicle): DutyType | undefined => {
  switch (vehicle.size) {
    case 'Pequeno':
      return DutyType.LIGHT;
    case 'Médio':
      return DutyType.MEDIUM;
    case 'Grande':
      return DutyType.HEAVY;
    default:
      return undefined;
  }
};
